import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';

import { ErrorHandlerService, AuthenticationService, NotyService } from '@app/services';
import { TranslateService } from '@ngx-translate/core';
import { LocaleInput } from '@app/models';
import { omit } from 'lodash';

export type ModalResult = void;
export interface ModalPublicProperties {
  email: string;
  sendVerification?: boolean;
  documentLocale?: LocaleInput;
}

@Component({
  selector: 'app-auth-email-confirmation-modal',
  templateUrl: './auth-email-confirmation-modal.component.html',
  styleUrls: ['./auth-email-confirmation-modal.component.scss'],
  standalone: false
})
export class AuthEmailConfirmationModalComponent implements OnInit, ModalPublicProperties {
  @Input() email: string;
  @Input() sendVerification? = false; // If sendVerification exists, force login instead of email verification (used only in sign flow)
  @Input() documentLocale: LocaleInput;

  isLoading = false;

  constructor(
    public modal: NgbActiveModal,
    private authenticationService: AuthenticationService,
    private errorHandlerService: ErrorHandlerService,
    private notyService: NotyService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    if (this.email && this.sendVerification) {
      this.sendEmailConfirmation(this.sendVerification);
    }
  }

  sendEmailConfirmation(hideSuccessMessage: boolean = false) {
    this.isLoading = true;
    this.authenticationService
      .sendEmailVerificationPrompt({
        email: this.email,
        ...(this.documentLocale ? { locale: omit(this.documentLocale, ['__typename']) } : {})
      })
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: () => {
          if (!hideSuccessMessage) {
            this.notyService.success(this.translateService.instant('notyService.confirmationEmailSent'));
          }
        },
        error: error => this.errorHandlerService.handle(error)
      });
  }

  nextStep(confirmation: boolean) {
    if (confirmation) this.modal.close();
  }
}
